export default __webpack_public_path__ + "static/media/square-left.0b618072.svg";